<div class="container">
    <div class="row" *ngIf="sent">
      <div class="col-md-6 offset-md-3 order-sm-12 m-t-40 m-b-10">
        <p class="alert alert-success">
            Password was successfully changed. Proceed to <a [routerLink]="['/login']">log in</a>.
        </p>
      </div>
    </div>
    <div class="row" *ngIf="!sent">
        <div class="col-md-6 offset-md-3 m-t-40 m-b-10">
            <alert></alert>
            <h2>Reset Your Password</h2>
            <form [formGroup]="resetForm" (ngSubmit)="reset()">
                <div class="form-group">
                    <label for="password">New Password</label>
                    <input type="password" class="form-control" formControlName="password"
                           placeholder="Enter new password"
                           [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                        <div *ngIf="f.password.errors.required">Password is required</div>
                        <div *ngIf="f.password.errors.strongPassword">
                            Password does not meet complexity requirements
                        </div>
                    </div>
                    <!-- Password strength indicator -->
                    <app-password-strength [password]="f.password.value" [showRequirements]="true"></app-password-strength>
                </div>
                <div class="form-group">
                    <label for="confirmPassword">Confirm Password</label>
                    <input type="password" class="form-control" formControlName="confirmPassword"
                           placeholder="Confirm new password"
                           [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                    <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                        <div *ngIf="f.confirmPassword.errors.required">Please confirm your password</div>
                        <div *ngIf="f.confirmPassword.errors.passwordMismatch">Passwords do not match</div>
                    </div>
                </div>
                <div class="form-group">
                    <button [disabled]="loading" class="btn btn-primary">
                        <span *ngIf="!loading">Change Password</span>
                        <span *ngIf="loading">
                            <i class="fa fa-spinner fa-spin"></i> Changing Password...
                        </span>
                    </button>
                </div>
                <div *ngIf="error" class="alert alert-danger">{{error}}</div>
            </form>
        </div>
    </div>
</div>